import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBsHUhdjZmA-UOMHragM6O4Nk6T6hrUlu8',
    libraries: 'places',
  },
})
